<template>
    <div id="mails">
        <div style="display: flex; width: 100%; height: 100%;">
            <NewMailInterface 
                mode="folder-only"
                defaultMode="normal"
                :default-selected-folder="selectedFolder"
                :default-selected-email-id="selectedEmailId"
                @folder-selected="changeFolder" 
                @email-selected="changeEmail"
            />
        </div>
    </div>
</template>

<script>
import { log2 } from "../../../../utils/log2";
import NewMailInterface from "../new/NewMailInterface.vue";

const log = log2("VisitorMailList");

export default {
    name: "Mails",
    components: {
        NewMailInterface
    },
    props: {
        selectedMail: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            selectedFolder: "inbox",
            selectedEmailId: this.selectedMail._id,
        };
    },
    methods: {
        changeFolder(folder) {
            this.selectedFolder = folder;
        },
        changeEmail(emailId) {
            this.selectedEmailId = emailId;
        },
    },
    mounted() {
        this.selectedEmailId = this.selectedMail._id;
    },
    watch: {
        selectedMail: {
            handler(newVal) {
                this.selectedEmailId = newVal._id;
            }
        }
    }
};
</script>

<style lang="scss">
#mails {
    background-color: #ffffff;
    height: 100%;
    width: 100%;
    display: flex;
}
</style>
